import { defineMessages } from 'react-intl';

export default defineMessages({
  noOptionsMessage: {
    id: 'components.atom.placeAutcomplete.noResult',
    defaultMessage: 'No results found',
  },
});
